@if (data?.testCase?.id) {
  <h2 mat-dialog-title>
    {{ 'AI_ASSISTANT.TESTING.EDIT_MODAL.EDIT_TITLE' | translate }}
    <mat-chip class="test-case-id" disableRipple>{{ data?.testCase?.id }}</mat-chip>
    <button
      type="button"
      mat-icon-button
      class="copy-id-button"
      [cdkCopyToClipboard]="data?.testCase?.id || ''"
      (cdkCopyToClipboardCopied)="onIdCopied()"
      [matTooltip]="'AI_ASSISTANT.TESTING.EDIT_MODAL.COPY_ID_TOOLTIP' | translate"
      [attr.aria-label]="'AI_ASSISTANT.TESTING.EDIT_MODAL.COPY_ID_ARIA_LABEL' | translate"
    >
      <mat-icon>{{ idCopied ? 'check' : 'content_copy' }}</mat-icon>
    </button>
  </h2>
} @else {
  <h2 mat-dialog-title>{{ 'AI_ASSISTANT.TESTING.EDIT_MODAL.CREATE_TITLE' | translate }}</h2>
}
<mat-dialog-content>
  <glxy-form-field required="true">
    <glxy-label>{{ 'AI_ASSISTANT.TESTING.EDIT_MODAL.TEST_NAME' | translate }}</glxy-label>
    <input
      [placeholder]="'AI_ASSISTANT.TESTING.EDIT_MODAL.TEST_NAME_PLACEHOLDER' | translate"
      [formControl]="form.name"
      type="text"
      matInput
    />
    @if (form.name.hasError('required')) {
      <glxy-error>{{ 'AI_ASSISTANT.TESTING.EDIT_MODAL.TEST_NAME_REQUIRED' | translate }}</glxy-error>
    }
  </glxy-form-field>

  <div class="success-evaluator">
    <mat-slide-toggle
      [checked]="form.isSuccessEvaluator.value"
      (change)="form.isSuccessEvaluator.setValue($event.checked); form.onEvaluatorToggle($event.checked)"
    >
      {{ 'AI_ASSISTANT.TESTING.EDIT_MODAL.SUCCESS_EVALUATOR_TOGGLE' | translate }}
    </mat-slide-toggle>
    @if (form.isSuccessEvaluator.value) {
      <glxy-form-field required="true">
        <glxy-label>{{ 'AI_ASSISTANT.TESTING.EDIT_MODAL.SCENARIO_LABEL' | translate }}</glxy-label>
        <textarea
          rows="2"
          matInput
          [placeholder]="'AI_ASSISTANT.TESTING.EDIT_MODAL.SCENARIO_PLACEHOLDER' | translate"
          [formControl]="form.scenario"
        ></textarea>
        @if (form.scenario.touched && form.scenario.hasError('required')) {
          <glxy-error>{{ 'AI_ASSISTANT.TESTING.EDIT_MODAL.SCENARIO_REQUIRED' | translate }}</glxy-error>
        }
      </glxy-form-field>

      <ai-constraints-field [constraintsForm]="form.constraints" [allowedActions]="invokeOnlyActions"></ai-constraints-field>
    }
  </div>

  @if (form.isVoice) {
    <glxy-form-field required="true">
      <glxy-label>{{ 'AI_ASSISTANT.TESTING.EDIT_MODAL.CALLER_INSTRUCTIONS' | translate }}</glxy-label>
      <textarea
        [placeholder]="'AI_ASSISTANT.TESTING.EDIT_MODAL.CALLER_INSTRUCTIONS_PLACEHOLDER' | translate"
        matInput
        [formControl]="form.callerInstructions"
      ></textarea>
      @if (form.callerInstructions.touched && !form.callerInstructions.value?.length) {
        <glxy-error>{{ 'AI_ASSISTANT.TESTING.EDIT_MODAL.CALLER_INSTRUCTIONS_REQUIRED' | translate }}</glxy-error>
      }
    </glxy-form-field>
  } @else {
    <h3>{{ 'AI_ASSISTANT.TESTING.EDIT_MODAL.CONVERSATION' | translate }}</h3>
    @for (chat of form.chatHistory.messages; track chat; let index = $index) {
      <div class="prompt">
        <glxy-form-field class="role" required="true" bottomSpacing="small">
          <glxy-label>{{ 'AI_ASSISTANT.TESTING.EDIT_MODAL.ROLE' | translate }}</glxy-label>
          <mat-select [formControl]="chat.role">
            <mat-option [value]="chatRoles.CHAT_MESSAGE_ROLE_USER">{{
              'AI_ASSISTANT.TESTING.EDIT_MODAL.ROLE_USER' | translate
            }}</mat-option>
            <mat-option [value]="chatRoles.CHAT_MESSAGE_ROLE_ASSISTANT">{{
              'AI_ASSISTANT.TESTING.EDIT_MODAL.ROLE_ASSISTANT' | translate
            }}</mat-option>
          </mat-select>
        </glxy-form-field>
        <glxy-form-field required="true" class="content" bottomSpacing="small">
          <glxy-label>{{ 'AI_ASSISTANT.TESTING.EDIT_MODAL.CONTENT' | translate }}</glxy-label>
          <textarea
            [placeholder]="'AI_ASSISTANT.TESTING.EDIT_MODAL.CONTENT_PLACEHOLDER_USER' | translate"
            matInput
            [formControl]="chat.content"
          ></textarea>
          @if (chat.content.hasError('required')) {
            @if (chat.content?.value === chatRoles.CHAT_MESSAGE_ROLE_USER) {
              <glxy-error>{{ 'AI_ASSISTANT.TESTING.EDIT_MODAL.CONTENT_REQUIRED_USER' | translate }}</glxy-error>
            } @else {
              <glxy-error>{{ 'AI_ASSISTANT.TESTING.EDIT_MODAL.CONTENT_REQUIRED_ASSISTANT' | translate }}</glxy-error>
            }
          }
        </glxy-form-field>
        @if (index > 0) {
          <button (click)="removeChatHistory(index)" mat-icon-button>
            <mat-icon>close</mat-icon>
          </button>
        }
      </div>
    }
    <button class="add-button" color="primary" (click)="addChatHistory()" mat-button>
      {{ 'AI_ASSISTANT.TESTING.EDIT_MODAL.ADD_CHAT' | translate }}
    </button>
  }

  <glxy-form-field>
    <glxy-label>{{ 'AI_ASSISTANT.TESTING.EDIT_MODAL.EXPECTATION_LABEL' | translate }}</glxy-label>
    <textarea
      [placeholder]="'AI_ASSISTANT.TESTING.EDIT_MODAL.EXPECTATION_PLACEHOLDER' | translate"
      matInput
      [formControl]="form.expectation"
    ></textarea>
    @if (form.expectation.hasError('required')) {
      <glxy-error>{{ 'AI_ASSISTANT.TESTING.EDIT_MODAL.EXPECTATION_REQUIRED' | translate }}</glxy-error>
    }
  </glxy-form-field>

  @if (!form.isVoice) {
    <glxy-form-field>
      <glxy-label>{{ 'AI_ASSISTANT.TESTING.EDIT_MODAL.AGENT_ARCHITECTURE' | translate }}</glxy-label>
      <mat-select [formControl]="form.agentArchitecture">
        <mat-option [value]="agentArchitectures.STANDARD">{{
          'AI_ASSISTANT.TESTING.EDIT_MODAL.ARCHITECTURE_STANDARD' | translate
        }}</mat-option>
        <mat-option [value]="agentArchitectures.REACT">{{
          'AI_ASSISTANT.TESTING.EDIT_MODAL.ARCHITECTURE_REACT' | translate
        }}</mat-option>
        <mat-option [value]="agentArchitectures.SUPERVISOR">{{
          'AI_ASSISTANT.TESTING.EDIT_MODAL.ARCHITECTURE_SUPERVISOR' | translate
        }}</mat-option>
      </mat-select>
    </glxy-form-field>
  }

  <h3>{{ 'AI_ASSISTANT.TESTING.CONTEXT.SECTION_LABEL' | translate }}</h3>
  <div class="invocation-context">
    <glxy-form-field>
      <glxy-label>{{ 'AI_ASSISTANT.TESTING.CONTEXT.CHANNEL_LABEL' | translate }}</glxy-label>
      <mat-select [formControl]="form.channel">
        @for (channel of channelOptions; track channel) {
          <mat-option [value]="channel">{{ getChannelName(channel) }}</mat-option>
        }
      </mat-select>
    </glxy-form-field>
    @if (showAuthAndApp) {
      <glxy-form-field>
        <glxy-label>{{ 'AI_ASSISTANT.TESTING.CONTEXT.AUTH_STATE_LABEL' | translate }}</glxy-label>
        <mat-select [formControl]="form.authState">
          <mat-option [value]="authStates.UNSET_AUTH_STATE">{{
            getAuthStateName(authStates.UNSET_AUTH_STATE)
          }}</mat-option>
          <mat-option [value]="authStates.ANONYMOUS">{{ getAuthStateName(authStates.ANONYMOUS) }}</mat-option>
          <mat-option [value]="authStates.AUTHENTICATED">{{ getAuthStateName(authStates.AUTHENTICATED) }}</mat-option>
        </mat-select>
      </glxy-form-field>
      <glxy-form-field>
        <glxy-label>{{ 'AI_ASSISTANT.TESTING.CONTEXT.APP_LABEL' | translate }}</glxy-label>
        <mat-select [formControl]="form.app">
          <mat-option [value]="apps.UNSET_APP">{{ getAppName(apps.UNSET_APP) }}</mat-option>
          <mat-option [value]="apps.BUSINESS_CENTER">{{ getAppName(apps.BUSINESS_CENTER) }}</mat-option>
          <mat-option [value]="apps.PARTNER_CENTER">{{ getAppName(apps.PARTNER_CENTER) }}</mat-option>
        </mat-select>
      </glxy-form-field>
    }
  </div>

  <h3>{{ 'AI_ASSISTANT.TESTING.EDIT_MODAL.EXPECTED_CITATIONS' | translate }}</h3>
  <button class="add-button" color="primary" (click)="addExpectedCitation()" mat-button>
    {{ 'AI_ASSISTANT.TESTING.EDIT_MODAL.ADD_CITATION' | translate }}
  </button>
  @for (citation of form.expectedCitations.citations; track citation; let index = $index) {
    <div class="tool">
      <div class="tool-fields">
        <div class="citation-type">
          <label class="citation-type-label">{{
            'AI_ASSISTANT.TESTING.EDIT_MODAL.CITATION_TYPE_LABEL' | translate
          }}</label>
          <mat-radio-group [formControl]="citation.type">
            <mat-radio-button [value]="citationTypes.UNSPECIFIED">{{
              'AI_ASSISTANT.TESTING.EDIT_MODAL.CITATION_TYPE_ANY' | translate
            }}</mat-radio-button>
            <mat-radio-button [value]="citationTypes.WEBSITE">{{
              'AI_ASSISTANT.TESTING.EDIT_MODAL.CITATION_TYPE_WEBSITE' | translate
            }}</mat-radio-button>
            <mat-radio-button [value]="citationTypes.BUSINESS_PROFILE">{{
              'AI_ASSISTANT.TESTING.EDIT_MODAL.CITATION_TYPE_BUSINESS_PROFILE' | translate
            }}</mat-radio-button>
            <mat-radio-button [value]="citationTypes.FILE">{{
              'AI_ASSISTANT.TESTING.EDIT_MODAL.CITATION_TYPE_FILE' | translate
            }}</mat-radio-button>
            <mat-radio-button [value]="citationTypes.USER_INPUT">{{
              'AI_ASSISTANT.TESTING.EDIT_MODAL.CITATION_TYPE_USER_INPUT' | translate
            }}</mat-radio-button>
          </mat-radio-group>
        </div>
        <glxy-form-field bottomSpacing="small">
          <glxy-label>{{ 'AI_ASSISTANT.TESTING.EDIT_MODAL.CITATION_TITLE_LABEL' | translate }}</glxy-label>
          <input
            [placeholder]="'AI_ASSISTANT.TESTING.EDIT_MODAL.CITATION_TITLE_PLACEHOLDER' | translate"
            [formControl]="citation.title"
            type="text"
            matInput
          />
        </glxy-form-field>
        <glxy-form-field bottomSpacing="small">
          <glxy-label>{{ 'AI_ASSISTANT.TESTING.EDIT_MODAL.CITATION_LINK_LABEL' | translate }}</glxy-label>
          <input
            [placeholder]="'AI_ASSISTANT.TESTING.EDIT_MODAL.CITATION_LINK_PLACEHOLDER' | translate"
            [formControl]="citation.link"
            type="text"
            matInput
          />
        </glxy-form-field>
      </div>
      <button (click)="removeExpectedCitation(index)" mat-icon-button>
        <mat-icon>close</mat-icon>
      </button>
    </div>
  }

  <div class="tool-settings">
    <h3>{{ 'AI_ASSISTANT.TESTING.EDIT_MODAL.TOOL_CALLS' | translate }}</h3>
    <mat-slide-toggle [(ngModel)]="form.expectedToolCalls.requireSpecificArguments">
      {{ 'AI_ASSISTANT.TESTING.EDIT_MODAL.REQUIRE_ARGUMENTS' | translate }}
    </mat-slide-toggle>
    <mat-slide-toggle [(ngModel)]="form.expectedToolCalls.requireSpecificResponse">
      {{ 'AI_ASSISTANT.TESTING.EDIT_MODAL.REQUIRE_RESPONSE' | translate }}
    </mat-slide-toggle>
  </div>
  <button class="add-button" color="primary" (click)="addExpectedToolCall()" mat-button>
    {{ 'AI_ASSISTANT.TESTING.EDIT_MODAL.ADD_TOOL_CALL' | translate }}
  </button>
  @for (tool of form.expectedToolCalls.tools; track tool; let index = $index) {
    <div class="tool">
      <div class="tool-fields">
        <glxy-form-field required="true" bottomSpacing="small">
          <glxy-label>{{ 'AI_ASSISTANT.TESTING.EDIT_MODAL.TOOL_NAME_LABEL' | translate }}</glxy-label>
          <input
            [placeholder]="'AI_ASSISTANT.TESTING.EDIT_MODAL.TOOL_NAME_PLACEHOLDER' | translate"
            [formControl]="tool.name"
            type="text"
            matInput
          />
        </glxy-form-field>
        @if (tool.arguments.enabled) {
          <glxy-form-field bottomSpacing="small">
            <glxy-label>{{ 'AI_ASSISTANT.TESTING.EDIT_MODAL.EXPECTED_ARGUMENTS' | translate }}</glxy-label>
            <input [placeholder]="argsPlaceholder" [formControl]="tool.arguments" type="text" matInput />
          </glxy-form-field>
        }
        @if (tool.response.enabled) {
          <glxy-form-field bottomSpacing="small">
            <glxy-label>{{ 'AI_ASSISTANT.TESTING.EDIT_MODAL.EXPECTED_RESPONSE' | translate }}</glxy-label>
            <input [placeholder]="responsePlaceholder" [formControl]="tool.response" type="text" matInput />
          </glxy-form-field>
        }
      </div>
      <button (click)="removeExpectedToolCall(index)" mat-icon-button>
        <mat-icon>close</mat-icon>
      </button>
    </div>
  }

  @if (showSyncHint) {
    <glxy-alert class="sync-hint" type="info" size="small" role="status" [showClose]="true" (close)="dismissSyncHint()">
      @if (form.isVoice) {
        {{ 'AI_ASSISTANT.TESTING.EDIT_MODAL.SYNC_HINT_VOICE' | translate }}
      } @else {
        {{ 'AI_ASSISTANT.TESTING.EDIT_MODAL.SYNC_HINT_CHAT' | translate }}
      }
    </glxy-alert>
  }
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-stroked-button (click)="close()">{{ 'AI_ASSISTANT.SHARED.CLOSE' | translate }}</button>
  <button mat-raised-button color="primary" (click)="save()">{{ 'AI_ASSISTANT.SHARED.SAVE' | translate }}</button>
</mat-dialog-actions>
